var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetfyLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.37,
    y1: 0.118,
    x2: 0.983,
    y2: 1.302,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#459ed8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c6fce"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Netfy_Logo_White_Square_g",
    transform: "translate(-2857.733 1736.291)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1516",
    "data-name": "Rectangle 1516",
    width: 115,
    height: 115,
    rx: 15,
    transform: "translate(2857.733 -1736.291)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Netfy_Logo_Gradient",
    d: "M21.653-5.31H16.93L7.437-21.191l-.1.016V-5.31H2.617V-28.857H7.34l9.493,15.866.1-.016V-28.857h4.722Zm11.564.34a7.874,7.874,0,0,1-6.113-2.4,8.8,8.8,0,0,1-2.2-6.186V-14.2a9.581,9.581,0,0,1,2.135-6.437,7.257,7.257,0,0,1,5.871-2.491,6.794,6.794,0,0,1,5.41,2.159A8.533,8.533,0,0,1,40.2-15.159v2.442H29.771l-.049.1a4.728,4.728,0,0,0,1.092,2.911,3.655,3.655,0,0,0,2.9,1.116,9.714,9.714,0,0,0,2.693-.323A10.987,10.987,0,0,0,38.7-9.9l1.278,2.911A8.765,8.765,0,0,1,37.13-5.552,12.623,12.623,0,0,1,33.216-4.97Zm-.307-14.523a2.623,2.623,0,0,0-2.191.978,4.908,4.908,0,0,0-.93,2.6l.032.081h5.758v-.356a4.087,4.087,0,0,0-.631-2.418A2.333,2.333,0,0,0,32.909-19.493Zm15.7-7.6v4.286h2.96v3.315h-2.96v8.911a2.033,2.033,0,0,0,.429,1.456,1.5,1.5,0,0,0,1.124.437,4.509,4.509,0,0,0,.647-.04,5.448,5.448,0,0,0,.631-.137l.388,3.412a9.561,9.561,0,0,1-1.383.364,8.244,8.244,0,0,1-1.464.121,5.033,5.033,0,0,1-3.76-1.342,5.886,5.886,0,0,1-1.318-4.253v-8.927H41.351v-3.315h2.555v-4.286Zm7.1,21.785V-19.493h-2.6v-3.315h2.6v-1.941a5.918,5.918,0,0,1,1.7-4.536,6.7,6.7,0,0,1,4.771-1.593,8.629,8.629,0,0,1,1.221.089q.623.089,1.367.251l-.4,3.51q-.388-.065-.752-.113a6.508,6.508,0,0,0-.849-.049,2.268,2.268,0,0,0-1.739.631,2.554,2.554,0,0,0-.59,1.811v1.941H63.8v3.315H60.435V-5.31Zm16.626-7.342.194.97h.1l3.348-11.127h5.078L73.956-2.69A9.262,9.262,0,0,1,71.934.472,5.186,5.186,0,0,1,68.1,1.758a5.927,5.927,0,0,1-1.108-.1q-.509-.1-1.237-.275l.55-3.445q.21.032.453.065a3.336,3.336,0,0,0,.437.032,2.574,2.574,0,0,0,1.8-.574,3.788,3.788,0,0,0,.97-1.431l.55-1.359L64.3-22.809h5.078Z",
    transform: "translate(2873.384 -1664.219)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetfyLogo);
export default __webpack_public_path__ + "static/media/netfy_Logo.ff8d0fe008c2d4811febccc0184a9535.svg";
export { ForwardRef as ReactComponent };